import { useNavigate } from "react-router-dom";
import { AssignedItemsView } from "@/features/admin/assigned-items/components/AssignedItemsView";

/** /admin/assigned-items — every review item and who has it. */
export function AssignedItemsPage() {
  const navigate = useNavigate();
  return <AssignedItemsView onOpenItem={(id) => navigate(`/admin/assigned-items/${encodeURIComponent(id)}`)} />;
}
